import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import QualityEditDialog from '../../Dialogs/Configuration/QualityEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function QualitiesTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getQualities = async function () {
            let url = `api/v1/quality/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getQualities();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'includesString'
        },
        {
            Header: 'Units',
            accessor: 'units',
            filter: 'includesString'
        },
        {
            Header: 'Numeric?',
            accessor: d => d.isNumeric === true ? "Yes" : "No",
            id: 'isNumeric',
            Filter: SelectFilter,
            options: ["Yes", "No"]
        },
        {
            Header: 'DPs',
            accessor: 'defaultDecimalPlaces',
            filter: 'includesString'
        },
        {
            Header: 'Value To Use',
            accessor: 'defaultValueToUse',
            filter: 'includesString'
        },
        {
            Header: 'Analysis',
            accessor: 'analysis',
            filter: 'includesString'
        },
        {
            Header: 'Component',
            accessor: 'component',
            filter: 'includesString'
        },
        {
            Header: 'Release Analysis',
            accessor: 'releaseAnalysis',
            filter: 'includesString'
        },
        {
            Header: 'Release Component',
            accessor: 'releaseComponent',
            filter: 'includesString'
        },
        {
            Header: 'Min Value',
            accessor: 'masterMinValue',
            filter: 'includesString'
        },
        {
            Header: 'Max Value',
            accessor: 'masterMaxValue',
            filter: 'includesString'
        },
        {
            Header: 'Specific Gravity',
            accessor: 'specificGravity',
            filter: 'includesString'
        },
        {
            Header: 'Confidence Value Min MD',
            accessor: 'confidenceValueMinMD',
            filter: 'includesString'
        },
        {
            Header: 'Transfer Calc',
            accessor: 'transferCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Transfer Offspec?',
            accessor: 'transferIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'Batch Calc',
            accessor: 'batchCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Batch Lab Calc',
            accessor: 'batchLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Calc',
            accessor: 'lotCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Lab Calc',
            accessor: 'lotLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Offspec?',
            accessor: 'lotIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'Secondary Lab Calc',
            accessor: 'secondaryLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            accessor: 'displayOrder'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    const initialState = {
        hiddenColumns: ['displayOrder'],
        sortBy: [
            {
                id: 'displayOrder',
                desc: false
            }
        ]
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={initialState} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function QualityConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewQuality = () => {
        return { qualityId: null, name: "", businessUnitId: null, isDeleted: false }
    };

    return (
        <CommonConfigPage
            title="Qualities"
            Table={QualitiesTable}
            Dialog={QualityEditDialog}
            getNewConfigObject={getNewQuality}
            businessUnits={businessUnits}
        />
    );
}

export default QualityConfiguration;